import { filter as adfFilter } from '@atlaskit/adf-utils/filter';
import type { DocNode } from '@atlaskit/adf-schema/doc';
import type { ADFEntity } from '@atlaskit/adf-utils/types';

export const getLinks = (content: DocNode): ADFEntity[] => {
	return adfFilter(content, (node) => (node.marks || []).some((mark) => mark.type === 'link'));
};
